'use client';

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { TextArea } from '@/components/ui/textarea';
import { useState } from 'react';
import { usePromptStore } from './store';

export function PromptDialog() {
  const current = usePromptStore((state) => state.current);
  const settle = usePromptStore((state) => state.settle);
  const [input, setInput] = useState('');

  // A new request can replace the current one without settling through this
  // component (the store declines the previous prompt) — reset the draft.
  const [prevPrompt, setPrevPrompt] = useState(current);
  if (current !== prevPrompt) {
    setPrevPrompt(current);
    setInput('');
  }

  const submit = () => {
    const trimmed = input.trim();
    if (trimmed.length < 3) {
      return;
    }
    settle(trimmed);
    setInput('');
  };

  const cancel = () => {
    settle(null);
    setInput('');
  };

  if (!current) {
    return null;
  }

  return (
    <AlertDialog open={!!current}>
      <AlertDialogContent>
        <AlertDialogHeader className='grid gap-2'>
          <AlertDialogTitle>
            {current.title ?? 'Denna åtgärd kräver en motivering'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            Vänligen ange orsaken till denna ändring så att godkännande part kan
            ta ställning till ändringen.
            {current.isBulk &&
              ' Samma motivering sparas på alla rader som ändras.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className='grid gap-2'>
          <Label htmlFor='motivation'>Motivering *</Label>
          <TextArea
            id='motivation'
            className='resize-none'
            placeholder='Ange motivering, minst 3 tecken...'
            rows={4}
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
        </div>
        <AlertDialogFooter>
          <Button variant='outline' onClick={cancel}>
            Avbryt
          </Button>
          <Button onClick={submit} disabled={input.trim().length < 3}>
            Spara
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
